// extracted by mini-css-extract-plugin
export default {"container":"OpeningInfoCard_container__y-MZG","imageWrapper":"OpeningInfoCard_imageWrapper__r0uD5","image":"OpeningInfoCard_image__CIC0O","content":"OpeningInfoCard_content__bQNYo"};